function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props),
/*#__PURE__*/
React.createElement("path", {
  d: "M444 256c-5 13-65 149-80 184-16 36-48 72-106 72H157c-61 0-93-36-93-100V136c0-37 51-35 51-2v121c0 10 18 10 18 0V60c0-38 56-37 56 0v184c0 10 17 10 17 0V28c0-37 56-38 56 0v219c0 9 18 10 18 0V63c0-35 61-36 61 0v208c0 13 13 15 18 5 4-9 23-51 23-51 19-39 82-15 62 31z"
})));